// extracted by mini-css-extract-plugin
export default {"wrapper":"order-summary_wrapper__nSCFH","walletIcon":"order-summary_walletIcon__i2GsR"};